/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Actions_LabelInputs */



/**
* | output |
* | --- |
* | "What you can ask here" |
*
* @param {Chat_Quick_Actions_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_actions_label = /** @type {((inputs?: Chat_Quick_Actions_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Actions_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wat je hier kan vragen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce que vous pouvez demander ici")
	return /** @type {LocalizedString} */ ("What you can ask here")
});